import React, { useEffect, useState } from "react";
import { SITE_KEY } from "../../keys";
import { Container } from "./styles";

function initApi() {
	const script = document.createElement("script");

	script.src = "https://www.google.com/recaptcha/enterprise.js";
	script.async = true;
	script.defer = true;
	document.body.appendChild(script);
}

export default function Recaptcha({ isValid, token }) {
	const [valid, setValid] = useState(false);
	const recaptcha = document.getElementsByClassName("g-recaptcha-response");
	initApi();

	useEffect(() => {
		if (recaptcha.length) {
			const key = { "recaptcha-token": recaptcha[0].value };
			if (key["recaptcha-token"].length) token(key);
		}
	}, [recaptcha.length, valid]);

	window.isValid = () => {
		setValid(!valid);
		return isValid(true);
	};
	return (
		<Container>
			<div className="g-recaptcha" data-callback="isValid" data-sitekey={SITE_KEY}></div>
		</Container>
	);
}
